import { GetCashOutRequestEntity, GetCashOutResponseEntity } from '@private/modules/cash-out-payment/core/entities';

export abstract class GetCashOutRepository {

  abstract getTransaction(params: GetCashOutRequestEntity): Promise<GetCashOutResponseEntity>;

}
